'use client';

import { __awaiter, __generator } from '../../_virtual/_tslib.js';
import { getResumeSettingInfo } from '../../services/resumes/index.js';

function getResume(params) {
    return __awaiter(this, void 0, void 0, function () {
        var accessToken, baseMsUrl, langCode, resumeSettingInfo, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    accessToken = params.accessToken, baseMsUrl = params.baseMsUrl, langCode = params.langCode;
                    return [4 /*yield*/, getResumeSettingInfo(accessToken, baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '', langCode)];
                case 1:
                    resumeSettingInfo = _a.sent();
                    if (!resumeSettingInfo) {
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/, resumeSettingInfo];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function getProfileLevel(params) {
    return __awaiter(this, void 0, void 0, function () {
        var baseMsUrl, langCode, accessToken, response, data, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    baseMsUrl = params.baseMsUrl, langCode = params.langCode, accessToken = params.accessToken;
                    return [4 /*yield*/, fetch("".concat(baseMsUrl, "/api-gateway/v1.0/profile/level"), {
                            method: 'GET',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': langCode
                            }
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
                case 3:
                    err_1 = _a.sent();
                    console.error(err_1);
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/];
            }
        });
    });
}

export { getProfileLevel, getResume };
//# sourceMappingURL=your-resume.js.map
